const splitColumns = (line) => line.trim().split(/\s+/);

export const parseTotalFlows = (response, bqnId) => {
  const [head, ...lines] = response.trim().split("\n");
  const fields = splitColumns(head);
  const activeIndex = fields.indexOf('ACTIVE');
  let result = 0;

  lines.forEach(line => {
    const values = splitColumns(line);
    if(!isNaN(values[activeIndex]) && (bqnId === 'all' || Number(values[0]) === Number(bqnId))){
      result += Number(values[activeIndex])
    }
  })

  return result;
};
